import * as devisConf from '@/configuration/devisConf';

export default function getTradByTypeFacture(type) {
  if (type === devisConf.NORMAL) return 'remiseBancaire.ajoutReglement.facture';
  return type;
}
